/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Pack_OnetimeInputs */

const en_pricing_pack_onetime = /** @type {(inputs: Pricing_Pack_OnetimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time`)
};

const de_pricing_pack_onetime = /** @type {(inputs: Pricing_Pack_OnetimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`einmalig`)
};

const fr_pricing_pack_onetime = /** @type {(inputs: Pricing_Pack_OnetimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`unique`)
};

const es_pricing_pack_onetime = /** @type {(inputs: Pricing_Pack_OnetimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`unico`)
};

const it_pricing_pack_onetime = /** @type {(inputs: Pricing_Pack_OnetimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`una tantum`)
};

const nl_pricing_pack_onetime = /** @type {(inputs: Pricing_Pack_OnetimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eenmalig`)
};

const pl_pricing_pack_onetime = /** @type {(inputs: Pricing_Pack_OnetimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jednorazowo`)
};

const fi_pricing_pack_onetime = /** @type {(inputs: Pricing_Pack_OnetimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kertamaksu`)
};

const da_pricing_pack_onetime = /** @type {(inputs: Pricing_Pack_OnetimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`engangs`)
};

const sv_pricing_pack_onetime = /** @type {(inputs: Pricing_Pack_OnetimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`engangs`)
};

/**
* | output |
* | --- |
* | "one-time" |
*
* @param {Pricing_Pack_OnetimeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_pack_onetime = /** @type {((inputs?: Pricing_Pack_OnetimeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Pack_OnetimeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_pack_onetime(inputs)
	if (locale === "fr") return fr_pricing_pack_onetime(inputs)
	if (locale === "es") return es_pricing_pack_onetime(inputs)
	if (locale === "it") return it_pricing_pack_onetime(inputs)
	if (locale === "nl") return nl_pricing_pack_onetime(inputs)
	if (locale === "pl") return pl_pricing_pack_onetime(inputs)
	if (locale === "fi") return fi_pricing_pack_onetime(inputs)
	if (locale === "da") return da_pricing_pack_onetime(inputs)
	if (locale === "sv") return sv_pricing_pack_onetime(inputs)
	return en_pricing_pack_onetime(inputs)
});